var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"co-back-home-button",attrs:{"to":"/"}},[_c('fa',{staticClass:"co-back-home-button__icon",attrs:{"icon":['fas', 'arrow-left']}}),_c('small',{staticClass:"u-a5 --uppercase"},[_vm._v("Back to home")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }